module.exports = __webpack_public_path__ + "static/media/icon-batting-style.e4413f11.svg";